/*
 * This will disable the default script included via Shopify app Script Tags,
 * thereby preventing conflicts with the new code.
 */
// eslint-disable-next-line no-unused-vars, no-implicit-globals
var tagalysDisableLegacyScript = true;

/**
 * Tagalys store configuration
 */
const setTagalysConfiguration = function() {
  window.Tagalys.setConfiguration({
    api: {
      serverUrl: window.theme.tagalysServerUrl,
      apiKey: window.theme.tagalysApiKey
    },
    locale: 'en-US',
    numberFormatter: function (number) {
      number = parseFloat(number)
      if(window.theme.store == "EU") {
        number = number.toFixed(2);
        number = number.toString();
        return number.replace(".",",");
      }else{
        number = number.toFixed(2);
        return number;
      }
    },
    currency: {
      displayFormatter:
        window.theme.currentCurrency === "PLN"
          ? "{{value}} {{currencyLabel}}"
          : "{{currencyLabel}}{{value}}",
      code: window.theme.currentCurrency,
      label: '<em class="currency-symbol">' + window.theme.currentCurrencySymbol + '</em>',
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided: function() {
      if (!window.theme.enableTagalysEventsTracking) return false;
      if (window.theme.consentGating && window.lovisaConsent) {
        return window.lovisaConsent.hasStatistics();
      }
      return true;
    },
    track:
      window.theme.enableTagalysEventsTracking &&
      (!window.theme.consentGating ||
        !window.lovisaConsent ||
        window.lovisaConsent.hasStatistics())
  });
};

function setPlatformConfigurationForTagalys() { // eslint-disable-line
  Tagalys.setPlatformConfiguration({
    platform: 'Shopify',
    countryCode: window.theme.tagalysCountryCode,
    baseCountryCode: window.theme.store === 'EU' ? 'DE' : window.theme.store,
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
    accessToken: window.theme.storefrontAPIToken,
    myShopifyDomain: window.theme.permanent_domain
    },
    metafields: {
      products: [{
        namespace: 'okendo',
        key: 'StarRatingSnippet'
      },
      {
        namespace: 'okendo',
        key: 'summaryData'
      }]
    }
  });
}

function refreshTagalysTrackingConfig() { // eslint-disable-line
  if (!window.Tagalys || !window.theme || !window.theme.tagalysServerUrl) return;
  setTagalysConfiguration();
}

function onTagalysReady(callback) { // eslint-disable-line
  function run() {
    setTagalysConfiguration();
    setPlatformConfigurationForTagalys();
    callback();
  }
  if (window.Tagalys) {
    run();
  } else {
    window.addEventListener('DOMContentLoaded', run);
  }
  if (window.theme && window.theme.consentGating) {
    window.addEventListener('lovisa:consent-updated', refreshTagalysTrackingConfig);
  }
}